import type { Router } from 'vue-router'
import { useAuthStore } from '@/store/modules/auth'

/**
 * 设置路由守卫
 */
export function setupRouterGuards(router: Router) {
  /**
   * 全局前置守卫
   * 处理权限验证、页面标题设置等
   */
  router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    const token = authStore.token
    // 设置页面标题
    // if (to.meta.title) {
    //   document.title = `${to.meta.title} - Electron Vue Vite`
    // }
    // 根据登录状态处理根路径重定向
    if (to.path === '/' || to.path === '') {
      if (token) {
        // 已登录用户访问根路径，重定向到/app
        next({ path: '/app' })
      } else {
        // 未登录用户访问根路径，重定向到/home
        next({ path: '/' })
      }
    } 
    // 检查是否需要登录
    else if (to.meta.requiresAuth && !token) {
      // 如果需要登录但没有token，重定向到登录页
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else if (token && to.name === 'Login') {
      // 如果已登录但访问登录页，重定向到app页面
      next({ path: '/app' })
    } else if (token && to.name === 'BindCompany') {
      const authStore = useAuthStore();
      if (authStore.userInfo?.companyName) {
        next({ path: '/app' });
      } else {
        next();
      }
    } else if (token && !to.name) {
      next({ name: 'AppNotFound' })
    } else if (token && to.meta.requiresAuth && !to.name?.includes('BindCompany') && !authStore.userInfo?.companyName) {
      ElMessage.warning('请先绑定公司名称');
      next({ name: 'BindCompany' });
    } else {
      next()
    }
  })
  
  /**
   * 全局后置钩子
   * 可以在这里添加页面加载完成后的操作
   */
  router.afterEach(() => {
    // 可以在这里添加页面加载完成后的操作
    // 例如：关闭加载动画、记录访问日志等
  })
  
  /**
   * 全局错误处理
   */
  router.onError((error) => {
    console.error('路由错误:', error)
  })
}